import { render, staticRenderFns } from "./ShokurekishoWithImageEdit.vue?vue&type=template&id=0008283b&scoped=true"
import script from "./ShokurekishoWithImageEdit.vue?vue&type=script&lang=js"
export * from "./ShokurekishoWithImageEdit.vue?vue&type=script&lang=js"
import style0 from "./ShokurekishoWithImageEdit.vue?vue&type=style&index=0&id=0008283b&prod&lang=scss&scoped=true"
import style1 from "./ShokurekishoWithImageEdit.vue?vue&type=style&index=1&id=0008283b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008283b",
  null
  
)

export default component.exports